/** @format */

import NotificationCard from '@atoms/NotificationCard';
import useStrings from '@common/application/hooks/useStrings/useStrings';
import { Notification } from '@common/model/apiClient/Notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ScrollView } from 'devextreme-react';
import { AnimatePresence, motion } from 'motion/react';
import { useSession } from 'next-auth/react';
import React from 'react';
import styles from './NotificationMenu.module.css';

interface NotifcationMenuProps {
  notifications: Array<Notification>;
}

const NotificationMenu = (props: NotifcationMenuProps) => {
  const { notificationStrings } = useStrings();
  const { data: session } = useSession();
  const queryClient = useQueryClient();

  const deleteAll = useMutation({
    mutationKey: ['delete_all_notifications', session?.user?.userId],
    mutationFn: () => Notification.deleteAllForUser(session?.user?.userId!),
    onSuccess: () => queryClient.invalidateQueries({ predicate: (query) => query.queryKey.includes('user_notification_query') }),
  });

  const markAllRead = useMutation({
    mutationKey: ['mark_all_notifications_read', session?.user?.userId],
    mutationFn: () => Notification.markAllRead(session?.user?.userId!),
    onSuccess: () => queryClient.invalidateQueries({ predicate: (query) => query.queryKey.includes('user_notification_query') }),
  });

  return (
    <div className={styles.container}>
      {/*<Arrow />*/}
      <h4>{notificationStrings.notificationsHeader}</h4>
      {!!props.notifications?.length && (
        <div className={styles.content}>
          <div>
            <ScrollView>
              <div className={styles.list} key={'notificationList'}>
                {props.notifications
                  .sort((a, b) => {
                    return (new Date(b.createdAt) as unknown as number) - (new Date(a.createdAt) as unknown as number);
                  })
                  .map((n) => (
                    <NotificationCard notification={n} key={n.id + 'notification'} />
                  ))}
              </div>
            </ScrollView>
          </div>
          <div className={styles.actions}>
            <span onClick={() => markAllRead.mutate()}>{notificationStrings.markAllRead}</span>
            <span onClick={() => deleteAll.mutate()}>{notificationStrings.clearAll}</span>
          </div>
        </div>
      )}
      {!props.notifications?.length && <div className={styles.empty}>{notificationStrings.noNotifications}</div>}
    </div>
  );
};

export default NotificationMenu;
